import { useState, useEffect } from "react";
import { Modal, Button, ActionIcon, Text, Loader, Flex } from "@mantine/core";
import { FiTrash2 } from "react-icons/fi";
import { deleteExpense } from "../../services/expenses"; // Adjust this import as per your services
import { getGlobalColor } from "../../services/globalColor.js";
import { getProducts } from "../../services/products";
import { usePermissions } from "../../contexts/PermissionsContext";

const ExpenseItem = ({ expense, getExpensesMethod }) => {
  const { hasPermission } = usePermissions();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const fetchProduct = async () => {
      if (expense?.productId) {
        try {
          const products = await getProducts();
          const foundProduct = products.find(
            (p) => p._id === expense.productId
          );
          setProduct(foundProduct);
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      }
    };

    fetchProduct();
  }, [expense?.productId]);

  const removeExpense = async () => {
    try {
      setLoading(true);
      await deleteExpense(expense._id); // Implement this function in your expenses service
      getExpensesMethod(); // Refresh the expenses list
      setConfirmDeleteModal(false);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getDisplayDate = () => {
    const raw = expense?.date || expense?.createdAt || expense?.updatedAt;
    if (!raw) return "-";
    try {
      const d = new Date(raw);
      return isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
    } catch {
      return "-";
    }
  };

  const getDisplayAmount = () => {
    const n = Number(expense?.amount);
    if (!Number.isFinite(n)) return String(expense?.amount ?? 0);
    return n.toLocaleString();
  };

  return (
    <>
      {/* Confirmation Modal for Deleting */}
      <Modal
        opened={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        title="¿Estás seguro que deseas eliminar este gasto?"
        centered
      >
        <div>
          <Flex
            justify="end"
            gap="10px"
            mt="md"
          >
            <Button
              variant="subtle"
              size="sm"
              onClick={removeExpense}
              disabled={loading}
            >
              {loading ? (
                <Loader
                  size="xs"
                  color="white"
                />
              ) : (
                "Sí"
              )}
            </Button>

            <Button
              size="sm"
              onClick={() => setConfirmDeleteModal(false)}
            >
              No
            </Button>
          </Flex>
        </div>
      </Modal>

      <tr key={expense.id}>
        <td>{getDisplayDate()}</td>
        <td>
          <Text
            size="sm"
            color={expense.title ? undefined : "dimmed"}
          >
            {expense.title || "Sin título"}
          </Text>
        </td>
        <td>
          {expense.productId ? (
            <>
              Compra de {expense.productStockQuantity}{" "}
              <b>{product?.name || "Producto no encontrado"}</b>
            </>
          ) : (
            <Text
              size="sm"
              color={expense.description ? undefined : "dimmed"}
            >
              {expense.description || "Sin descripción"}
            </Text>
          )}
        </td>
        <td>${getDisplayAmount()}</td>
        <td style={{ textAlign: "right" }}>
          {hasPermission({ feature: "gastos", action: "Eliminar" }) && (
            <ActionIcon
              color={getGlobalColor().color}
              onClick={() => setConfirmDeleteModal(true)}
              variant="filled"
              aria-label="Eliminar"
              style={{
                margin: "4px",
                color: getGlobalColor().text || "white",
              }}
            >
              <FiTrash2
                style={{
                  color: getGlobalColor().contrast || getGlobalColor().text,
                }}
              />
            </ActionIcon>
          )}
        </td>
      </tr>
    </>
  );
};

export default ExpenseItem;
